module.exports = __webpack_public_path__ + "static/media/loading-dots.704137f8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/assets/loading-dots.gif
// module id = 503
// module chunks = 0